



































import Vue from 'vue'
import { sprintf } from 'sprintf-js'
import { getText } from '../js/lang'

export default Vue.extend({
  name: 'check-ticket',
  props: {
    lang: {
      type: String,
      required: true
    },
    ticketId: {
      type: String,
      default: ''
    }
  },
  methods: {
    l(key: string, ...values: any[]): string {
      return sprintf(getText(this.lang, key), ...values)
    }
  }
})
